import { isNumber } from 'lodash'
import { format } from '../number'
import { toFraction } from '../math'
import { ODDS_FORMAT } from '../../constants'
import oddsDictionary from './odds.dictionary.js'

const ODDS_NA = 'n/a'

const oddsDictionaryFormatMap = {
  [ODDS_FORMAT.FRACTIONAL]: 0,
  [ODDS_FORMAT.AMERICAN]: 1,
  [ODDS_FORMAT.HONGKONG]: 2,
  [ODDS_FORMAT.INDONESIAN]: 3,
  [ODDS_FORMAT.MALAY]: 4
}

function getDictionaryOdds (odds, oddsFormatType) {
  const formatIndex = oddsDictionaryFormatMap[oddsFormatType]
  // Using rounded to 3 digits odds as the index
  const oddsIndex = Number(odds).toFixed(3)
  const oddsFormats = oddsDictionary[oddsIndex]

  if ((isNumber(formatIndex)) && (formatIndex >= 0) && oddsFormats) {
    return oddsFormats[formatIndex]
  }

  return null
}

/*
  Formatting Odds to format

  @return String formattedOdds
*/
export function formatOdds (odds, oddsFormatType, options = {}) {
  const formattedOdds = Number.parseFloat(odds)

  if (!formattedOdds) {
    return ODDS_NA
  }

  if (oddsFormatType === ODDS_FORMAT.DECIMAL) {
    return format(
      formattedOdds,
      {
        /*
          By default odds got fixed number of digits after point
        */
        fixed: true,
        /*
          Handing cases for 0.001 and 0.005
          For less then 0.01 applying 3 fraction digits
        */
        fractionDigits: formattedOdds < 1.01 ? 3 : 2,
        ...options
      }
    )
  }

  /*
    Trying to resolve dictionary odds for non decimal odds format types
  */
  const dictionaryOdds = getDictionaryOdds(odds, oddsFormatType)

  if (dictionaryOdds) {
    return dictionaryOdds
  }

  if (oddsFormatType === ODDS_FORMAT.FRACTIONAL) {
    // Fractional presents as non number value type
    // So we dont useing numbet formatting
    return formatOddsToFractional(formattedOdds)
  }

  if (oddsFormatType === ODDS_FORMAT.AMERICAN) {
    return format(
      formatOddsToAmerican(formattedOdds),
      {
        showPositiveSymbol: true,
        fractionDigits: 0
      }
    )
  }

  if (oddsFormatType === ODDS_FORMAT.HONGKONG) {
    return format(
      formatOddsToHongKong(formattedOdds)
    )
  }

  if (oddsFormatType === ODDS_FORMAT.INDONESIAN) {
    return format(
      formatOddsToIndonesian(formattedOdds),
      {
        showPositiveSymbol: true
      }
    )
  }

  if (oddsFormatType === ODDS_FORMAT.MALAY) {
    return format(
      formatOddsToMalay(formattedOdds),
      {
        showPositiveSymbol: true
      }
    )
  }

  return formattedOdds + '?'
}

export function formatOddsToFractional (x) {
  return toFraction(x - 1)
}

export function formatOddsToAmerican (x) {
  if (x >= 2) {
    return 100 * (x - 1)
  } else {
    return -100 / (x - 1)
  }
}

export function formatOddsToHongKong (x) {
  return (x - 1)
}

export function formatOddsToIndonesian (x) {
  if (x >= 2) {
    return (x - 1)
  } else {
    return -1 / (x - 1)
  }
}

export function formatOddsToMalay (x) {
  if (x > 2) {
    return -1 / (x - 1)
  } else {
    return (x - 1)
  }
}
